import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const BUILTIN = ["courses", "gear", "workshop", "killhouse", "ethos", "gallery", "partners", "contact"];

export const SLOTS = [
  { key: "hero", label: "Opening photo", multi: true, hint: "Add more than one and they cycle automatically" },
  { key: "course-cqb-1", label: "Course · Fundamentals" },
  { key: "course-cqb-2", label: "Course · Team Movement" },
  { key: "course-cqb-3", label: "Course · Low-Light Ops" },
  { key: "course-cqb-4", label: "Course · Force on Force" },
  { key: "workshop", label: "Workshop" },
  { key: "killhouse", label: "Killhouse background" },
  { key: "ethos", label: "Ethos" },
  { key: "gallery", label: "Gallery", multi: true, hint: "Photos slide across the Gallery section" },
];

export const DEFAULT_IMAGES = {
  hero: ["/img/op-door.jpg"],
  "course-cqb-1": ["/img/fundamentals.jpg"],
  "course-cqb-2": ["/img/op-team.jpg"],
  "course-cqb-3": ["/img/lowlight.jpg"],
  "course-cqb-4": ["/img/fof-team.jpg"],
  workshop: ["/img/workshop.jpg"],
  killhouse: ["/img/killhouse-maze.jpg"],
  ethos: ["/img/op-team.jpg"],
  gallery: ["/img/op-outdoor.jpg", "/img/killhouse.jpg", "/img/op-night.jpg", "/img/op-door.jpg", "/img/fof-team.jpg", "/img/lowlight.jpg"],
};

const blankSection = (key) => ({ key, visible: true, custom: false, title_en: "", title_pt: "", body_en: "", body_pt: "", images: [] });

export const normalize = (cfg) => {
  const saved = Array.isArray(cfg?.sections) ? cfg.sections.filter((s) => s.custom || BUILTIN.includes(s.key)) : [];
  const missing = BUILTIN.filter((k) => !saved.some((s) => s.key === k)).map(blankSection);
  return { sections: [...saved, ...missing], images: cfg?.images || {}, texts: cfg?.texts || { en: {}, pt: {} } };
};

export const mediaUrl = (u) => (u?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [config, setConfig] = useState(() => normalize(null));
  const reload = useCallback(() => {
    api.get("/site").then((r) => setConfig(normalize(r.data?.config))).catch(() => {});
  }, []);
  useEffect(() => { reload(); }, [reload]);
  const imgs = (key) => {
    const list = config.images?.[key];
    return (Array.isArray(list) && list.length ? list : DEFAULT_IMAGES[key] || []).map(mediaUrl);
  };
  const img = (key) => imgs(key)[0];
  return <SiteContext.Provider value={{ config, reload, imgs, img }}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);
